import React, { useState, useEffect } from 'react';
import { CrownIcon, ReloadIcon } from '../icons/SVGs';
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';

const SidePanel = ({ children, hide, show, outsideClick: allowOutsideClick = true, startOver }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [enableOutsideClick, setEnableOutsideClick] = useState(allowOutsideClick);

    useEffect(() => {
        // Enable outside click only after panel is shown
        if (show) {
            const timer = setTimeout(() => {
                setEnableOutsideClick(allowOutsideClick);
            }, 500); // Wait for transition to complete
            return () => clearTimeout(timer);
        }
    }, [show, allowOutsideClick]);

    const list = [
        {
            svg: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.0002 22.7522C14.7302 22.7522 14.4802 22.6022 14.3502 22.3722C14.2202 22.1322 14.2202 21.8522 14.3602 21.6122L15.4102 19.8622C15.6202 19.5022 16.0902 19.3922 16.4402 19.6022C16.8002 19.8122 16.9102 20.2722 16.7002 20.6322L16.4302 21.0822C19.1902 20.4322 21.2602 17.9522 21.2602 14.9922C21.2602 14.5822 21.6002 14.2422 22.0102 14.2422C22.4202 14.2422 22.7602 14.5822 22.7602 14.9922C22.7502 19.2722 19.2702 22.7522 15.0002 22.7522Z"
                        fill="url(#paint0_linear_10747_12979)"
                    />
                    <path
                        d="M2 9.75C1.59 9.75 1.25 9.41 1.25 9C1.25 4.73 4.73 1.25 9 1.25C9.27 1.25 9.52 1.4 9.65 1.63C9.78 1.87 9.78 2.15 9.64 2.39L8.59 4.14C8.38 4.49 7.92 4.61 7.56 4.39C7.21 4.18 7.09 3.72 7.31 3.36L7.58 2.91C4.81 3.56 2.75 6.04 2.75 9C2.75 9.41 2.41 9.75 2 9.75Z"
                        fill="url(#paint1_linear_10747_12979)"
                    />
                    <path
                        d="M14.8 12.6331V15.5731C14.8 18.0231 13.82 19.0031 11.37 19.0031H8.43C5.98 19.0031 5 18.0231 5 15.5731V12.6331C5 10.1831 5.98 9.20312 8.43 9.20312H11.37C13.82 9.20312 14.8 10.1831 14.8 12.6331Z"
                        fill="url(#paint2_linear_10747_12979)"
                    />
                    <path
                        d="M15.5709 5H12.6309C10.2209 5 9.24094 5.96 9.21094 8.32H11.3709C14.3109 8.32 15.6709 9.69 15.6709 12.62V14.78C18.0409 14.75 18.9909 13.77 18.9909 11.36V8.43C19.0009 5.98 18.0209 5 15.5709 5Z"
                        fill="url(#paint3_linear_10747_12979)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_10747_12979"
                            x1="14.2539"
                            y1="15.4704"
                            x2="23.0216"
                            y2="15.8632"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint1_linear_10747_12979"
                            x1="1.25"
                            y1="2.4768"
                            x2="10.0074"
                            y2="2.86913"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint2_linear_10747_12979"
                            x1="5"
                            y1="10.6176"
                            x2="15.1012"
                            y2="11.0703"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint3_linear_10747_12979"
                            x1="9.21094"
                            y1="6.41155"
                            x2="19.2916"
                            y2="6.86335"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: t("Unlimited Access"),
            description: t("Unlimited downloads and file processing"),
        },
        {
            svg: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M19.5017 7.50281L18.0117 8.99281L15.0117 5.99281L16.5017 4.50281C16.9217 4.08281 17.4617 3.88281 18.0017 3.88281C18.5417 3.88281 19.0817 4.08281 19.5017 4.50281C20.3317 5.33281 20.3317 6.67281 19.5017 7.50281Z"
                        fill="url(#paint0_linear_10747_13659)"
                    />
                    <path
                        d="M17.3114 9.70312L6.50141 20.5031C5.67141 21.3331 4.33141 21.3331 3.50141 20.5031C2.67141 19.6731 2.67141 18.3331 3.50141 17.5031L14.3114 6.70312L17.3114 9.70312Z"
                        fill="url(#paint1_linear_10747_13659)"
                    />
                    <path
                        d="M9.95051 3.50051L10.3605 2.11051C10.4005 1.98051 10.3605 1.84051 10.2705 1.74051C10.1805 1.64051 10.0205 1.60051 9.89051 1.64051L8.50051 2.05051L7.11051 1.64051C6.98051 1.60051 6.84051 1.64051 6.74051 1.73051C6.64051 1.83051 6.61051 1.97051 6.65051 2.10051L7.05051 3.50051L6.64051 4.89051C6.60051 5.0205 6.64051 5.16051 6.73051 5.26051C6.83051 5.36051 6.97051 5.39051 7.10051 5.35051L8.50051 4.95051L9.89051 5.36051C9.93051 5.37051 9.96051 5.38051 10.0005 5.38051C10.1005 5.38051 10.1905 5.34051 10.2705 5.27051C10.3705 5.17051 10.4005 5.03051 10.3605 4.90051L9.95051 3.50051Z"
                        fill="url(#paint2_linear_10747_13659)"
                    />
                    <path
                        d="M5.95051 9.50051L6.36051 8.1105C6.40051 7.9805 6.36051 7.84051 6.27051 7.74051C6.17051 7.64051 6.03051 7.61051 5.90051 7.65051L4.50051 8.05051L3.1105 7.64051C2.9805 7.60051 2.84051 7.64051 2.74051 7.73051C2.64051 7.83051 2.61051 7.97051 2.65051 8.10051L3.05051 9.50051L2.64051 10.8905C2.60051 11.0205 2.64051 11.1605 2.73051 11.2605C2.83051 11.3605 2.9705 11.3905 3.1005 11.3505L4.4905 10.9405L5.88051 11.3505C5.91051 11.3605 5.95051 11.3605 5.9905 11.3605C6.0905 11.3605 6.18051 11.3205 6.26051 11.2505C6.36051 11.1505 6.39051 11.0105 6.35051 10.8805L5.95051 9.50051Z"
                        fill="url(#paint3_linear_10747_13659)"
                    />
                    <path
                        d="M20.9517 14.5L21.3617 13.11C21.4017 12.98 21.3617 12.84 21.2717 12.74C21.1717 12.64 21.0317 12.61 20.9017 12.65L19.5117 13.06L18.1217 12.65C17.9917 12.61 17.8517 12.65 17.7517 12.74C17.6517 12.84 17.6217 12.98 17.6617 13.11L18.0717 14.5L17.6617 15.89C17.6217 16.02 17.6617 16.16 17.7517 16.26C17.8517 16.36 17.9917 16.39 18.1217 16.35L19.5117 15.94L20.9017 16.35C20.9317 16.36 20.9717 16.36 21.0117 16.36C21.1117 16.36 21.2017 16.32 21.2817 16.25C21.3817 16.15 21.4117 16.01 21.3717 15.88L20.9517 14.5Z"
                        fill="url(#paint4_linear_10747_13659)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_10747_13659"
                            x1="15.0117"
                            y1="4.62034"
                            x2="20.2813"
                            y2="4.85663"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint1_linear_10747_13659"
                            x1="2.87891"
                            y1="8.78472"
                            x2="17.7549"
                            y2="9.45191"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint2_linear_10747_13659"
                            x1="6.625"
                            y1="2.16703"
                            x2="10.493"
                            y2="2.34026"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint3_linear_10747_13659"
                            x1="2.625"
                            y1="8.16518"
                            x2="6.49126"
                            y2="8.33884"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                        <linearGradient
                            id="paint4_linear_10747_13659"
                            x1="17.6445"
                            y1="13.1718"
                            x2="21.5039"
                            y2="13.3452"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: t("Advanced Tools"),
            description: t("Edit text, OCR, compression & batch processing"),
        },
        {
            svg: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.74 12.9089C21.48 12.0489 21.05 11.2989 20.48 10.6889C19.75 9.85888 18.78 9.28888 17.69 9.03888C17.14 6.53888 15.6 4.73888 13.41 4.06888C11.03 3.32888 8.27 4.04888 6.54 5.85888C5.02 7.44888 4.52 9.63888 5.11 11.9689C3.11 12.4589 2.12 14.1289 2.01 15.7189C2 15.8289 2 15.9289 2 16.0289C2 17.9089 3.23 20.0189 5.97 20.2189H16.35C17.77 20.2189 19.13 19.6889 20.17 18.7389C21.8 17.3089 22.4 15.0789 21.74 12.9089Z"
                        fill="url(#paint0_linear_10747_13746)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_10747_13746"
                            x1="2"
                            y1="6.15369"
                            x2="22.5985"
                            y2="7.27716"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: t("Cloud & Sharing"),
            description: t("Cloud storage and secure document sharing"),
        },
        {
            svg: (
                <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 0C17.0609 0 18.0783 0.421427 18.8284 1.17157C19.5786 1.92172 20 2.93913 20 4V12C20 13.0609 19.5786 14.0783 18.8284 14.8284C18.0783 15.5786 17.0609 16 16 16H11.276L6.514 18.857C6.37059 18.9431 6.20788 18.9918 6.04077 18.9987C5.87366 19.0056 5.70749 18.9705 5.55746 18.8966C5.40743 18.8227 5.27833 18.7123 5.18199 18.5756C5.08565 18.4389 5.02514 18.2802 5.006 18.114L5 18V16H4C2.97376 16 1.98677 15.6056 1.24319 14.8983C0.499605 14.191 0.0563122 13.225 0.00500011 12.2L0 12V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H16ZM13.2 9.286C13.0106 9.10038 12.7553 8.99757 12.4901 9.00019C12.2249 9.00282 11.9717 9.11066 11.786 9.3C11.5532 9.53766 11.2753 9.72647 10.9687 9.85536C10.662 9.98426 10.3327 10.0507 10 10.0507C9.66733 10.0507 9.33801 9.98426 9.03133 9.85536C8.72465 9.72647 8.44678 9.53766 8.214 9.3C8.0274 9.11503 7.7755 9.01093 7.51276 9.0102C7.25002 9.00948 6.99755 9.11219 6.80993 9.29613C6.62231 9.48007 6.51462 9.73045 6.51014 9.99316C6.50567 10.2559 6.60476 10.5098 6.786 10.7C7.20498 11.1275 7.70505 11.4672 8.25692 11.6991C8.8088 11.9309 9.40139 12.0504 10 12.0504C10.5986 12.0504 11.1912 11.9309 11.7431 11.6991C12.295 11.4672 12.795 11.1275 13.214 10.7C13.3996 10.5106 13.5024 10.2553 13.4998 9.9901C13.4972 9.72493 13.3893 9.47167 13.2 9.286ZM7.51 5H7.5C7.23478 5 6.98043 5.10536 6.79289 5.29289C6.60536 5.48043 6.5 5.73478 6.5 6C6.5 6.26522 6.60536 6.51957 6.79289 6.70711C6.98043 6.89464 7.23478 7 7.5 7H7.51C7.77522 7 8.02957 6.89464 8.21711 6.70711C8.40464 6.51957 8.51 6.26522 8.51 6C8.51 5.73478 8.40464 5.48043 8.21711 5.29289C8.02957 5.10536 7.77522 5 7.51 5ZM12.51 5H12.5C12.2348 5 11.9804 5.10536 11.7929 5.29289C11.6054 5.48043 11.5 5.73478 11.5 6C11.5 6.26522 11.6054 6.51957 11.7929 6.70711C11.9804 6.89464 12.2348 7 12.5 7H12.51C12.7752 7 13.0296 6.89464 13.2171 6.70711C13.4046 6.51957 13.51 6.26522 13.51 6C13.51 5.73478 13.4046 5.48043 13.2171 5.29289C13.0296 5.10536 12.7752 5 12.51 5Z"
                        fill="url(#paint0_linear_10743_13958)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_10743_13958"
                            x1="-4.78292e-09"
                            y1="2.7422"
                            x2="20.6102"
                            y2="3.71456"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#F2BF4B" />
                            <stop offset="1" stop-color="#CD7C2E" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: t("AI Features"),
            description: t("Smart tools and automated processing"),
        },
    ];
    return (
        <div className={`fixed z-50 inset-0 overflow-hidden flex justify-end ${!show ? 'pointer-events-none overflow-hidden' : ''}`}>
            <div
                className={`fixed inset-0 bg-black backdrop-blur-lg bg-opacity-25 transition-opacity z-0 ${show ? 'opacity-100' : 'opacity-0'} ${enableOutsideClick && show ? 'pointer-events-auto' : 'pointer-events-none'}`}
                onClick={() => {
                    if (enableOutsideClick && show) {
                        hide();
                    }
                }}
            />
            <div className={`z-50 relative h-screen overflow-hidden flex flex-col md:flex-row max-w-6xl w-full bg-white text-left transform transition-all duration-500 
                ${show ?
                    i18n.language === "ar" ? "translate-x-0" : "translate-x-0"
                    : i18n.language === "ar" ? "-translate-x-[200%]" : "translate-x-full"
                }
                  ${i18n.language === "ar" ? "lg:rounded-r-2xl" : "lg:rounded-l-2xl"}
                `}
                style={{ zIndex: 9999 }}
            >
                <div className="w-full flex flex-col flex-1 h-screen relative order-1 md:order-0 p-5 overflow-y-auto">
                    <div className="flex items-center justify-center w-full md:pt-5">
                        <div className="flex items-center md:my-8 md:mt-3 gap-2 text-secondary-1000 md:text-base text-sm border border-warning-200/50 bg-warning-100/10 rounded-2xl py-4 px-3">
                            <svg
                                className="flex-shrink-0 md:size-7 size-6"
                                width="18"
                                height="16"
                                viewBox="0 0 18 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4.0013 15.6641C3.76519 15.6641 3.56742 15.5841 3.40797 15.4241C3.24853 15.2641 3.16853 15.0663 3.16797 14.8307C3.16742 14.5952 3.24742 14.3974 3.40797 14.2374C3.56853 14.0774 3.7663 13.9974 4.0013 13.9974H14.0013C14.2374 13.9974 14.4355 14.0774 14.5955 14.2374C14.7555 14.3974 14.8352 14.5952 14.8346 14.8307C14.8341 15.0663 14.7541 15.2643 14.5946 15.4249C14.4352 15.5855 14.2374 15.6652 14.0013 15.6641H4.0013ZM4.58464 12.7474C4.18186 12.7474 3.82436 12.6155 3.51214 12.3516C3.19992 12.0877 3.0088 11.7543 2.9388 11.3516L2.10547 6.0599C2.07769 6.0599 2.04658 6.06351 2.01214 6.07073C1.97769 6.07795 1.9463 6.08129 1.91797 6.08073C1.57075 6.08073 1.27575 5.95934 1.03297 5.71656C0.790193 5.47379 0.668526 5.17851 0.667971 4.83073C0.667415 4.48295 0.789082 4.18795 1.03297 3.94573C1.27686 3.70351 1.57186 3.58184 1.91797 3.58073C2.26408 3.57962 2.55936 3.70129 2.8038 3.94573C3.04825 4.19018 3.16964 4.48518 3.16797 4.83073C3.16797 4.92795 3.15742 5.01823 3.1363 5.10156C3.11519 5.1849 3.09103 5.26129 3.0638 5.33073L5.66797 6.4974L8.27214 2.9349C8.11936 2.82379 7.99436 2.67795 7.89714 2.4974C7.79991 2.31684 7.7513 2.1224 7.7513 1.91406C7.7513 1.56684 7.87297 1.27156 8.1163 1.02823C8.35964 0.784898 8.65464 0.663509 9.0013 0.664064C9.34797 0.66462 9.64325 0.786287 9.88714 1.02906C10.131 1.27184 10.2524 1.56684 10.2513 1.91406C10.2513 2.1224 10.2027 2.31684 10.1055 2.4974C10.0082 2.67795 9.88325 2.82379 9.73047 2.9349L12.3346 6.4974L14.9388 5.33073C14.911 5.26129 14.8866 5.1849 14.8655 5.10156C14.8444 5.01823 14.8341 4.92795 14.8346 4.83073C14.8346 4.48351 14.9563 4.18823 15.1996 3.9449C15.443 3.70156 15.738 3.58018 16.0846 3.58073C16.4313 3.58129 16.7266 3.70295 16.9705 3.94573C17.2144 4.18851 17.3357 4.48351 17.3346 4.83073C17.3335 5.17795 17.2121 5.47323 16.9705 5.71656C16.7288 5.9599 16.4335 6.08129 16.0846 6.08073C16.0569 6.08073 16.0257 6.0774 15.9913 6.07073C15.9569 6.06406 15.9255 6.06045 15.8971 6.0599L15.0638 11.3516C14.9944 11.7543 14.8035 12.0877 14.4913 12.3516C14.1791 12.6155 13.8213 12.7474 13.418 12.7474H4.58464Z"
                                    fill="url(#paint0_linear_10802_13760)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_10802_13760"
                                        x1="3.28627"
                                        y1="5.2846"
                                        x2="26.3122"
                                        y2="7.99372"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stop-color="#F2BF4B" />
                                        <stop offset="1" stop-color="#CD7C2E" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <span>
                                {t(
                                    "This feature is exclusive to our Paid plan. Upgrade to gain access."
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="py-5 flex-1 flex flex-col items-center justify-center text-center w-full max-w-lg mx-auto">{children}</div>
                    <Button
                        className="!w-full my-8 max-w-lg mx-auto flex"
                        variant="btn-secondary"
                        iconStart={<ReloadIcon className="w-4.5 h-4.5" />}
                        value={t("Start Over")}
                        onClick={() => {
                            hide();
                            setTimeout(() => {
                                if (startOver) startOver();
                                navigate(`/${i18n.language}`);
                            }, 300);
                        }}
                    />
                    <div className="flex justify-center items-center text-center w-full mx-auto max-w-lg">
                        <p className="text-grey-800 text-sm font-normal">
                            {t("By signing in or creating an account, you agree with our")}{" "}
                            <a
                                href={`${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/terms-and-conditions`}
                                className="text-primary font-normal text-sm mx-1"
                            >
                                {t("Terms & conditions")}
                            </a>
                            {t("&")}
                            <a
                                href={`${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/privacy-statement`}
                                className="text-primary font-normal text-sm mx-1"
                            >
                                {t("Privacy statement")}
                            </a>
                        </p>
                    </div>
                </div>
                <div className="bg-gradient-side-panel md:max-w-sm lg:max-w-md max-w-full w-full order-0 md:order-1 relative hidden md:block">
                    <div className="bg-gradient-pro w-full text-center md:text-2xl text-xl tracking-wide flex items-center justify-center gap-4 font-medium py-3.5 text-grey-200">
                        <CrownIcon className="size-7" />
                        {t("Premium Features")}
                    </div>
                    <ul className="lg:p-12 md:p-6 p-4 grid sm:grid-cols-2 grid-cols-1 md:gap-5 gap-4 md:flex flex-col">
                        {list.map((item, index) => (
                            <li
                                key={index}
                                className="bg-white/10 rounded-xl md:py-5 md:px-6 p-4"
                            >
                                <div className="flex items-center gap-2 mb-2">
                                    {item.svg}
                                    <p className="md:text-lg sm:text-base text-sm font-medium text-white tracking-wide">
                                        {item.title}
                                    </p>
                                </div>
                                <p className="md:text-sm text-xs text-white tracking-wide">
                                    {item.description}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default SidePanel;